import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { UserRoles } from "../../../user/user.constants";
import { getCurrentUser } from "../../../user/user.selectors";
import { getRulesForCurrentUser } from "../../../content/content.selectors";

import colors from "../../../../utils/colors";
import {DarkLogoMtv} from "../../../../ui/LogoMtv";
import BaseContainer from "../../../../ui/BaseContainer";
import { media } from "../../../../utils/uiSizes";
import Icon from "../../../../icons/Icon";
import NavLink from "react-router-dom/es/NavLink";

const StyledFooter = styled.footer`
  width: 100%;
  box-sizing: border-box;
  padding: 1rem 1rem 7rem;
  position: absolute;
  bottom: 0;
  background-color: ${colors.BLACK};
  font-size: 0.9375rem;
  height: 40rem;

  ${media.tablet`
  	height: 20rem;
  	padding: 1rem 3rem 7rem;
  `} color: ${colors.GRAY};
  a {
    color: ${colors.GRAY_LIGHTER};
    font-size: inherit;
    vertical-align: middle;
  }
`;

const StyledHead = styled.div`
  width: 100%;
  max-width: 1350px;
  margin: 0 auto 1rem;

  > * {
    align-items: left;
  }
`;

const StyledContent = BaseContainer.extend`
  margin: 0 auto;
  display: block;

  ${media.tablet`
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	`} ul {
    width: 49%;
    margin: 1rem 0 0 1.5rem;
    ${media.tablet`
			margin: inherit;
			width: 24%;
		`} line-height: 1.5rem;

    li {
      svg {
        fill: ${colors.GRAY_LIGHTER};
        stroke: none;
        float: left;
        width: 1.4375rem;
        height: 1.4375rem;
        margin-right: 0.25rem;
        margin-left: -0.25rem;
      }
    }
  }
`;

const AppFooter = props => {
  const { currentUser, rules } = props;
  return (
    <StyledFooter {...props}>
      <StyledHead>
        <DarkLogoMtv withByline={false} />
      </StyledHead>
      <StyledContent>
        <ul>
          <li>
            <a
              href="http://www.mtv.fi/"
              target="_blank"
              rel="noopener noreferrer"
            >
              MTV
            </a>
          </li>
          <li>
            <NavLink to="/privacy">Yleiset käyttöehdot ja tietosuoja</NavLink>
          </li>
          {currentUser &&
            currentUser.hasAccessToPrizeProgram &&
            rules &&
            currentUser.role !== UserRoles.SUPERUSER && (
              <li>
                <Link to="/prizes/rules">Säännöt</Link>
              </li>
            )}
        </ul>
        <ul>
          <li>
            <a
              href="https://www.facebook.com/mtv3suomi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon="#facebook" />
              MTV Facebook
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com/mtv3suomi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon="#twitter" />
              MTV Twitter
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/mtv3suomi/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon="#instagram" />
              MTV Instagram
            </a>
          </li>
        </ul>
        <ul>
          <li>
            Ota yhteyttä:<br />
            <a href="mailto:sisapiiri.mtv@mtv.fi">sisapiiri.mtv@mtv.fi</a>
          </li>
        </ul>
        <ul>
          <li>
            MTV Oy, Kuluttajaliiketoiminta<br />
            Konepajankuja 7, 00510 Helsinki<br />postiosoite: 00033 MTV<br />
            Puh: 010 300 300 etunimi.sukunimi@mtv.fi
          </li>
        </ul>
      </StyledContent>
    </StyledFooter>
  );
};

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  const rulesContent = getRulesForCurrentUser(state);
  const rules = rulesContent.length > 0 ? rulesContent[0] : null;
  return {
    currentUser,
    rules
  };
};

const ConnectedAppFooter = connect(mapStateToProps, null)(AppFooter);

export default ConnectedAppFooter;



// WEBPACK FOOTER //
// ./src/modules/common/components/app/AppFooter.js